import React,{Component} from 'react';

class UserListItem extends Component{

  constructor(props){
    super(props);
    this.sendTestMessageToUser = this.sendTestMessageToUser.bind(this);
  }
  sendTestMessageToUser(){
    this.props.sendTestMessageToUser(this.props.user);
  }

  
 

  render(){
   let styleClass = "workerListItem";
    

      return (
        <li className={styleClass} key={this.props.user._id}  id={this.props.user._id}  >
              
              <span className="usernameField">{this.props.user.name}</span><button className="sendTestMessageButton"><span className="glyphicon glyphicon-send" onClick={this.sendTestMessageToUser}>&nbsp;</span></button>

        </li>
      )

  }
}
export default UserListItem;
